const PlanejamentoContratoPagamento = () => import('../../../spa/planejamento-contrato/form/passo-acoes/PlanejamentoContratoFormAcoesContratoVisualizacao');

export default {
  path: 'analise-acao',
  name: 'analise-acao',
  component: PlanejamentoContratoPagamento,
};
